import React, { useCallback, useState, useEffect } from 'react';
import { Fragment } from 'react';
import { useGroupBy, useTable, useFilters, useGlobalFilter, useSortBy } from 'react-table';
import Cell from '../cell/cell.component';
import Toolbar from '../toolbar/toolbar.component';
import './table.styles.css';
import { removeDuplicate } from '../../../Utility/utils';
 
const Tabella = ({columns, data, groupColumn, hiddenColumns, filtersData, onEventClick, onDateData}) => {
  const initialState = {groupBy: groupColumn, hiddenColumns: hiddenColumns};
  const [dropdownData, setDropdownData] = useState([]);
  
  
  // Create a function that will render our row sub components
  const renderRowSubComponent = useCallback(({ row }) => <Cell row={row} onEventClick={onEventClick}/>,[]);

   // function to manage the sort
  const handleSortBy = (colId, descending, isMulti = false) => {
    toggleSortBy(colId, descending, isMulti);
  }

  const handleMapFilter = (colId, category) => {
    setFilter(colId, category);
  }
  
// this useEffect is used to memorize the api data for the autocomplete component from ui material design.
// removeDuplicate is the func created in utility. It will give back the value we want.
useEffect(() => {
    setDropdownData(removeDuplicate(data, 'place'))
  }, [data]) //api data array[]

  
  useEffect(() => {
    const filter = filtersData
    .filter(item => item.isChecked === true)
    .map(category => category.id);

   handleMapFilter('eventType', filter);

  }, [filtersData]);
 
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        visibleColumns,
        preGlobalFilteredRows,
        setGlobalFilter,
        toggleSortBy,
        setFilter,
        state: { groupBy, globalFilter },
      } = useTable({ columns, data, initialState }, useFilters, useGlobalFilter, useGroupBy, useSortBy);
 
    return (
        <div className="tableWrap">
          <Toolbar
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              handleSortBy={handleSortBy}
              dropdownData={dropdownData}
          />
            <table className="table_root" {...getTableProps()}>
            <thead>
            </thead>
                {/* Apply the table body props */}
                <tbody {...getTableBodyProps()}>
                    {// Loop over the table rows
                    rows.map(row => {
                        // Prepare the row for display
                        prepareRow(row)
                        return (
                          // Apply the row props
                          <Fragment key={row.id}>
                            <tr {...row.getRowProps()}>
                            {// Loop over the rows cells
                              row.cells.map(cell => {
                                // Apply the cell props
                                return (
                                  <td {...cell.getCellProps()} >
                                    {// Render the cell contents
                                      cell.render('Cell')
                                    }
                                  </td>
                                  )
                              })}
                            </tr>
                            <tr>
                              <td colSpan={visibleColumns.length}>
                                {renderRowSubComponent({ row })}
                              </td>
                            </tr>
                          </Fragment>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}
 
export default Tabella;